import type { FinanceProduct, ListResponseFinancialProductType } from "@classes-service-types/index.ts";
import type { UseQueryReturnType } from "@tanstack/vue-query";
import { type UseQueryOptions, useQuery } from "@tanstack/vue-query";
import type { Ref } from "vue";
import { computed } from "vue";
import financialProductTypes from "@/services/financialProductTypes.js";

interface Args {
  limit: number;
  page: number;
  q: Ref<string>;
  useQueryOptions?: Partial<UseQueryOptions<FinanceProduct[]>>;
}

type UseGetFinancialTypesDataFunc = (args: Args) => UseQueryReturnType<FinanceProduct[], Error>;

export const useGetFinancialTypesData: UseGetFinancialTypesDataFunc = ({ limit, page, q, useQueryOptions }) => {
  const fetchFinancialTypes = (): Promise<FinanceProduct[]> =>
    financialProductTypes
      .getFinancialProductTypes({ limit: limit, page: page, q: q?.value ?? "" })
      .then((val: { data?: ListResponseFinancialProductType }) => val?.data?.data?.items);
  return useQuery<FinanceProduct[]>({
    queryKey: computed(() => ["financialTypes", limit, page, q]),
    queryFn: fetchFinancialTypes,
    ...useQueryOptions,
  });
};
